var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C14.6569 0 16 1.34315 16 3V11C16 12.6569 14.6569 14 13 14H10.4142L8.70711 15.7071C8.31658 16.0976 7.68342 16.0976 7.29289 15.7071L5.58579 14H3C1.34315 14 0 12.6569 0 11V3C0 1.34315 1.34315 0 3 0H13ZM13 2H3C2.44772 2 2 2.44772 2 3V11C2 11.5523 2.44772 12 3 12H6C6.26522 12 6.51957 12.1054 6.70711 12.2929L8 13.5858L9.29289 12.2929C9.48043 12.1054 9.73478 12 10 12H13C13.5523 12 14 11.5523 14 11V3C14 2.44772 13.5523 2 13 2ZM11 8C11.5523 8 12 8.44771 12 9C12 9.55229 11.5523 10 11 10H5C4.44772 10 4 9.55229 4 9C4 8.44771 4.44772 8 5 8H11ZM11 4C11.5523 4 12 4.44772 12 5C12 5.55228 11.5523 6 11 6H5C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4H11Z",
    fill: "#292F49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.fa5e452a944ff8e2aa0164af86e60dce.svg";
export { ForwardRef as ReactComponent };